import React from 'react'

export type ThumbsUpIconProps = {
  size?: number
  /** Stroke color. Defaults to `currentColor` so the parent controls theming. */
  color?: string
  className?: string
}

export const ThumbsUpIcon = ({
  size = 15,
  color = 'currentColor',
  className,
}: ThumbsUpIconProps) => (
  <svg
    aria-label='Thumbs up'
    className={className}
    fill='none'
    height={size}
    role='img'
    viewBox='0 0 15 15'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.375 6.875V12.5M4.375 6.875H2.5C2.33424 6.875 2.17527 6.94085 2.05806 7.05806C1.94085 7.17527 1.875 7.33424 1.875 7.5V11.875C1.875 12.0408 1.94085 12.1997 2.05806 12.3169C2.17527 12.4342 2.33424 12.5 2.5 12.5H4.375M4.375 6.875L6.875 2.5C7.20652 2.5 7.52446 2.6317 7.75888 2.86612C7.9933 3.10054 8.125 3.41848 8.125 3.75V5.625H11.5625C11.6995 5.62475 11.8349 5.65454 11.9592 5.71227C12.0834 5.77 12.1935 5.85426 12.2817 5.95912C12.3699 6.06399 12.434 6.18691 12.4696 6.31923C12.5051 6.45155 12.5112 6.59006 12.4875 6.725L11.7375 10.7875C11.8159 10.9832 11.8436 11.1956 11.8178 11.4049C11.7921 11.6142 11.7138 11.8136 11.5903 11.9845C11.4668 12.1554 11.3021 12.2923 11.1114 12.3825C10.9208 12.4726 10.7105 12.513 10.5 12.5H4.375'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.25}
    />
  </svg>
)
